module.exports = __webpack_public_path__ + "static/media/8.129e62fc.svg";